export const makeConstantFactory = (prefix) => (constant) =>
  `@@app/${prefix}/${constant}`
